import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod/v4';

/** Optional `?planId=<id>` opens the edit drawer (SWOOP-287); SWOOP-286's Edit buttons set it. */
const searchSchema = z.object({
  planId: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/settings_/maintenance/service-plans')({
  component: lazyRouteComponent(() => import('&/features/settings/maintenance/pages/service-plans-page')),
  staticData: { titleKey: 'servicePlans' },
  validateSearch: (search) => searchSchema.parse(search),
});
